<avla-modal
  class="relative"
  [name]="getModalName"
  type="right"
  [icon]="{ type: 'class', icon: 'close', class: 'material-symbols-rounded' }"
>
  <div class="avla_modal_section__header">
    <p class="text-2xl font-semibold text-light-blue mt-16">Guía</p>
    <p class="text-gray-2 text-xs mt-2 font-light">
      Descubre todo lo que Venta en Verde te ofrece.
    </p>
  </div>
  <div class="avla_modal_section__body">
    <div
      *ngIf="currentDriver"
      class="absolute overflow-y-scroll max-h-[70vh] pb-40"
    >
      <div class="flex flex-row gap-4 mt-8">
        <p class="font-semibold">{{ currentDriver?.title || "" }}</p>
      </div>
      <div class="flex flex-row gap-4">
        <p class="text-gray-2 text-xs font-light">
          {{ currentDriver?.descriptions || "" }}
        </p>
      </div>
      <div
        class="mt-4 flex flex-row gap-4 items-start"
        *ngFor="let driver of currentDriver.driver['steps']; let i = index"
      >
        <img
          class="cursor-pointer"
          src="assets/svg/play_circle.svg"
          alt="Logo de play"
          (click)="play(currentDriver?.url, i)"
        />
        <div class="text-m flex gap-3">
          <div class="text-light-blue font-semibold">{{ i + 1 }}.</div>
          <div>
            <span class="text-light-blue font-semibold"
              >{{ driver?.popover?.title }}:
            </span>
            <span
              class="text-gray-2 font-light"
              [innerHTML]="driver?.popover?.description"
            >
            </span>
          </div>
        </div>
      </div>
    </div>
    <form [formGroup]="formSwitch" class="flex items-center absolute bottom-11 bg-white">
      <span
        *ngIf="formSwitch.get('switch').value"
        [class]="getTextSwitchClassInactive"
        class="mr-3"
        >Desactivar tour</span
      >
      <span
        *ngIf="!formSwitch.get('switch').value"
        [class]="getTextSwitchClassActive"
        class="mr-3"
        >Desactivado</span
      >
      <avla-switch
        class="relative top-[4px] avla-switch-primary"
        [id]="'switch'"
        (change)="onChangeSwitch()"
        [active]="formSwitch.get('switch').value"
        [form]="formSwitch"
      >
      </avla-switch>
      <span
        *ngIf="!formSwitch.get('switch').value"
        [class]="getTextSwitchClassInactive"
        class="mr-3"
        >Activar tour</span
      >
      <span
        *ngIf="formSwitch.get('switch').value"
        [class]="getTextSwitchClassActive"
        class="mr-3"
        >Activado</span
      >
    </form>
  </div>
</avla-modal>
